import session from './session';

const FileDownload = require('js-file-download');


const TIMEOUT_MS = 200000;


export default {
  generateTable(currentLocationId) {
    return session.get('/api/generate_table', {timeout: TIMEOUT_MS, params: { currentLocationId }});
  },
  saveChanges(changes) {
    return session.post('/api/updated_products/save_changes', {changes}, {timeout: TIMEOUT_MS});
  },
  downloadProductUpdateFiles(updateEntityId) {
    return session.get(`/api/updated_products/${updateEntityId}/files`, {timeout: TIMEOUT_MS, responseType: 'blob'}).then((response) => {
        const datetime = (new Date()).toISOString().slice(0, 19).replace(/-/g, '').replace(/:/g, '').replace('T', '.');
        FileDownload(response.data, `generated_products_update_${datetime}.zip`);
    });
  },
  getProductUpdateBarcodes(updateEntityId) {
    return session.get(`/api/updated_products/${updateEntityId}/barcodes`);
  },
  /*
  getSummaryReportTable(category, supplier, data) {
    console.log("category, supplier", category, supplier, data)
    return session.get(`/api/get_summary_report`, { timeout: TIMEOUT_MS, params: { category, supplier } });
  },
  */
  getSummaryReportTable(aggregateBy, timeFrame, currentLocationId) {
    if (timeFrame !== null) {
      timeFrame = `${timeFrame[0].valueOf()},${timeFrame[1].valueOf()}`;
    }
    return session.get('/api/get_summary_report', { timeout: TIMEOUT_MS, params: { aggregateBy, timeFrame, currentLocationId } });
  },
  saveProductChanges(changes) {
    return session.post('/api/update_product/', {changes}, {timeout: TIMEOUT_MS});
  }
};



// WEBPACK FOOTER //
// ./src/api/products.js